import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-primary/30 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-154" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-155" data-mp="2vppmn6uzk4c8">
        <div className="text-center" data-id="element-156" data-mp="39hw36u21wdc7">
          <SectionHeading id="problem-title" data-id="element-157" data-mp="39gul45mmaqkz">Does This Sound <span className="text-accent" data-id="element-158" data-mp="39jqjtw6ahjah">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-muted" data-id="element-159" data-mp="35g10pm8dvtwu">
            You work in operations, HSE, maintenance, engineering or environmental management, and every time the news
            says &quot;El Niño is coming&quot; the same questions appear: Will it rain more or less at our site? Can our
            drainage handle it? What happens to our water supply, our power, our workers in the heat, our roads and our
            suppliers? Forecasts arrive full of indices and probabilities, and turning them into concrete decisions for
            your site is not easy.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-primary/70 bg-surface/80 p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-160" data-mp="sdtg9itwdm0x">
          <p className="mb-5 inline-flex items-center gap-2 font-display text-2xl font-extrabold uppercase text-foreground" data-id="element-161" data-mp="1714q9gafkxyx">
            <AlertTriangleIcon className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-162" data-mp="1bzobtfl447qr" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-163" data-mp="3dtf9g6uaffr7">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-muted" data-id="element-164" data-mp="3dv8l60jrcq62">
                <span className="glow-line mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-highlight" aria-hidden="true" data-id="element-165" data-mp="3hv0u4ed2cyby" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-166" data-mp="k30hjn1zcybp">
          <p className="mx-auto max-w-2xl text-lg font-bold text-foreground" data-id="element-167" data-mp="y0oywkwu9nc0">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 font-display text-3xl font-extrabold uppercase tracking-tight text-accent sm:text-4xl" data-id="element-168" data-mp="ty254eglxsc6">You need one organized system.</p>
        </div>
      </div>
    </section>;
}